import styled from 'styled-components';
import { HorizontalTabBar } from '@insurancemenu/imenu-components-lib';

export const HorizontalTabBarStyled = styled(HorizontalTabBar)`
  margin-bottom: 6rem;
`;
